import { useMutation, useQueryClient } from "@tanstack/react-query";

import { API_URL } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useDeleteGoogleFileSearchStore = (provider = "google") => {
  const auth = useAuth();
  const userContext = useUser();
  const workspaceId = userContext?.activeWorkspaceId;
  const qc = useQueryClient();

  return useMutation(
    async (params: { name: string }) => {
      const response = await fetch(`${API_URL}/api/dashboard/v2/google-file-search-store/delete`, {
        method: "POST",
        headers: jsonAuthHeaders(auth!.userToken!),
        body: JSON.stringify({
          name: params.name,
          workspace_id: workspaceId,
          provider,
        }),
      }).then(handleResponse);

      if (response && typeof response === "object" && "success" in response) {
        if (response.success === false) {
          const errorMessage =
            (response as { message?: string }).message || "Failed to delete file search store";
          throw new Error(errorMessage);
        }
      }

      return response;
    },
    {
      onSuccess: () => {
        qc.invalidateQueries({
          queryKey: ["google-file-search-stores", workspaceId, provider],
        });
      },
    },
  );
};
